/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightBagSelection
 */
export interface FlightBagSelection {
  /**
   *
   * @type {string}
   * @memberof FlightBagSelection
   */
  selectionToken: string;
  /**
   *
   * @type {number}
   * @memberof FlightBagSelection
   */
  quantity: number;
}

/**
 * Check if a given object implements the FlightBagSelection interface.
 */
export function instanceOfFlightBagSelection(
  value: object
): value is FlightBagSelection {
  if (!("selectionToken" in value) || value["selectionToken"] === undefined)
    return false;
  if (!("quantity" in value) || value["quantity"] === undefined) return false;
  return true;
}

export function FlightBagSelectionFromJSON(json: any): FlightBagSelection {
  return FlightBagSelectionFromJSONTyped(json, false);
}

export function FlightBagSelectionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBagSelection {
  if (json == null) {
    return json;
  }
  return {
    selectionToken: json["selection_token"],
    quantity: json["quantity"],
  };
}

export function FlightBagSelectionToJSON(json: any): FlightBagSelection {
  return FlightBagSelectionToJSONTyped(json, false);
}

export function FlightBagSelectionToJSONTyped(
  value?: FlightBagSelection | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    selection_token: value["selectionToken"],
    quantity: value["quantity"],
  };
}
